import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createEntityContact, deleteEntityContact, getEntityContacts, setEntityPrimaryContact, updateEntityContact } from "../../api/entities/Contact";
import { ContactForm } from "../../types/forms/entity";

export const useEntityContact = (entityIdStr?: string) => {
  const queryClient = useQueryClient();
  const entityId = Number(entityIdStr);

  const queryKey = ["entity", entityId, "Contact"];

  const result = useQuery({
    queryKey,
    queryFn: () => getEntityContacts(entityId),
    enabled: !!entityId,
  });

  const createMutation = useMutation({
    mutationFn: (values: ContactForm) => createEntityContact(entityId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  const updateMutation = useMutation({
    mutationFn: ({ ContactId, values }: { ContactId: number, values: ContactForm }) => updateEntityContact(entityId, ContactId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  const deleteMutation = useMutation({
    mutationFn: (ContactId: number) => deleteEntityContact(entityId, ContactId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  const setPrimaryMutation = useMutation({
    mutationFn: (ContactId: number) => setEntityPrimaryContact(entityId, ContactId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  return {
    contactsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createContact: createMutation.mutateAsync,
    updateContact: updateMutation.mutateAsync,
    deleteContact: deleteMutation.mutateAsync,
    setPrimaryContact: setPrimaryMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending || setPrimaryMutation.isPending,
  }
}